import React from 'react';

/**
 * Componente que convierte un texto en inglés en palabras interactivas sin alterar los espacios naturales.
 * Al hacer clic en cualquier palabra, invoca onWordClick(palabra).
 */
export default function InteractiveText({ text, onWordClick, className = "" }) {
  if (!text) return null;

  // Normalizar múltiples espacios en blanco consecutivos
  const normalizedText = String(text).replace(/\s+/g, ' ');
  const words = normalizedText.split(' ');

  return (
    <span className={className}>
      {words.map((wordToken, idx) => {
        const cleanWord = wordToken.replace(/[^a-zA-Z']/g, '');

        return (
          <React.Fragment key={idx}>
            {idx > 0 && ' '}
            {cleanWord ? (
              <span
                onClick={(e) => {
                  e.stopPropagation();
                  if (onWordClick) {
                    onWordClick(cleanWord, wordToken);
                  }
                }}
                title="Haz clic para ver la traducción en español y escuchar la pronunciación 📖"
                className="hover:bg-blue-600/30 hover:text-blue-200 hover:underline cursor-pointer rounded px-0.5 transition inline"
              >
                {wordToken}
              </span>
            ) : (
              <span>{wordToken}</span>
            )}
          </React.Fragment>
        );
      })}
    </span>
  );
}
